import { render, staticRenderFns } from "./KgjtWebsiteHonorEdit.vue?vue&type=template&id=6b0b389e&scoped=true&"
import script from "./KgjtWebsiteHonorEdit.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteHonorEdit.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteHonorEdit.vue?vue&type=style&index=0&id=6b0b389e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b389e",
  null
  
)

export default component.exports